import { useContext, createContext } from "react";

export type AuthToken = string;

export enum AuthState {
  Idle = 1,
  Loading,
  SignedIn,
  SignedOut,
}

export interface AuthorizedRequestArg {
  authToken: AuthToken;
}

interface Auth {
  authToken: AuthToken | null;
  state: AuthState;
}

export const authContext = createContext<Auth>({
  authToken: null,
  state: AuthState.Idle,
});

export const useAuth = () => {
  return useContext(authContext);
};